"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _utils = require("../../utils");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _richTextField = require("../../lib/richTextField");
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _imageSrc = require("../../lib/imageSrc");
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a horizontal Line card
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A horizontal Line card
 */
function HorizontalLineCard(props) {
  if (!props.rendering.fields) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var {
    linkUrl,
    linkTarget,
    linkAlt
  } = (0, _linkFieldSrc.linkFieldSrc)(extractedFields.Link.value);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "app-container card--basic no-border card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, !(0, _lodash.isEmpty)(extractedFields.Heading.value) && /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-auto"
  }, (0, _titleHeadTag.headTagTitle)(extractedFields.Heading, 'mm-spacing', extractedFields.HeadingSize.value))), extractedFields.CardList.map((cards, key) => {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, {
      key: key
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
      key: key
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 4
    }, !(0, _lodash.isEmpty)(cards.fields.Image.value) && /*#__PURE__*/_react.default.createElement("picture", {
      className: "mm-img"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: (0, _imageSrc.imageHref)(cards.fields.Image.value),
      alt: cards.fields.Image.value.alt
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object"
    }, !(0, _lodash.isEmpty)(cards.fields.Icon.value) && /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(cards.fields.Icon.value, " icon-lg"),
      style: {
        marginRight: '1.6rem'
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, !(0, _lodash.isEmpty)(cards.fields.Title.value) && /*#__PURE__*/_react.default.createElement("span", {
      className: "data-sm",
      style: {
        display: 'inline-block'
      }
    }, (0, _richTextField.parseHTML)(cards.fields.Title))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 8
    }, !(0, _lodash.isEmpty)(cards.fields.BodyText.value) && /*#__PURE__*/_react.default.createElement("div", {
      className: "card-text"
    }, (0, _richTextField.parseHTML)(cards.fields.BodyText)))), extractedFields.CardList.length !== key + 1 ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 12
    }, /*#__PURE__*/_react.default.createElement("hr", null))) : /*#__PURE__*/_react.default.createElement("p", {
      className: "mm-spacing"
    }));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", null, !(0, _lodash.isEmpty)(extractedFields.Eyebrow.value) && /*#__PURE__*/_react.default.createElement("p", {
    className: "eyebrow"
  }, extractedFields.Eyebrow.value), /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: extractedFields.ButtonType.value,
    href: linkUrl,
    target: linkTarget,
    linkAlt: linkAlt,
    label: extractedFields.Text.value,
    icon: extractedFields.ctaIcon.value,
    iconDirection: extractedFields.ctaIconPlacement.value,
    dataId: extractedFields.ctaDataId.value
  }))));
}
var _default = exports.default = HorizontalLineCard;